module.exports = __webpack_public_path__ + "static/img/dingqi@2x.28611ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/pc/dingqi@2x.png
// module id = 9Ydp
// module chunks = 1